import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { DeliverableCompletedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/DeliverableCompletedProgressionActions'

export interface DeliverableCompletedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}

export const DeliverableCompletedProgressionActionsContainer = observer(
  function DeliverableCompletedProgressionActionsContainer({
    vm,
    canCompleteJob,
  }: DeliverableCompletedProgressionActionsContainerProps) {
    return (
      <DeliverableCompletedProgressionActions
        canCompleteJob={canCompleteJob}
        onCompleteJob={vm.closeJob}
      />
    )
  },
)
